import {rgba} from 'polished';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import {colors} from 'styles/shared';

const ItemRow = styled.div`
  height: 6.9rem;
  border-bottom: ${props => (props.lastItem ? null : `0.2rem solid ${rgba(colors.darkBlue_lighter, 0.3)}`)};
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
`;

const Ellipse = styled.div`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  margin-right: 1.5rem;
  background: ${props => props.color};
`;

const Title = styled.div`
  font-size: 2.5rem;
  line-height: 2.2rem;
  color: ${colors.darkBlue_main};
  width: 100%;
`;

AccordionItem.propTypes = {
  item: PropTypes.object.isRequired
};

AccordionItem.defaultProps = {
  className: ''
};

function AccordionItem({className, item}) {
  return (
    <>
      <ItemRow lastItem={item.lastItem} className={className}>
        <ItemContainer>
          <Ellipse color={item.color} />

          <Title>
            {item.currency}
            {item.amount} - {item.date}
          </Title>
        </ItemContainer>
      </ItemRow>
    </>
  );
}

export default AccordionItem;
